/**
 * UranIA PA — Env vars accessor (US-009).
 *
 * Tutte le env Vite sono `VITE_*` (resto = stripped a build time).
 * Niente segreti (lato client niente client_secret, ADR-005 §3 + ADR-006 §6):
 * il flusso OIDC è code+PKCE pubblico.
 */

export interface SpaEnv {
  readonly oidcAuthority: string;
  readonly oidcClientId: string;
  readonly oidcRedirectUri: string;
  readonly oidcPostLogoutRedirectUri: string;
  readonly oidcSilentRedirectUri: string;
  readonly apiBaseUrl: string;
  readonly auditUiEndpoint: string;
}

function readEnv(name: keyof ImportMetaEnv, fallback: string): string {
  const value: unknown = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    return fallback;
  }
  return value;
}

export function loadSpaEnv(): SpaEnv {
  return {
    oidcAuthority: readEnv('VITE_OIDC_AUTHORITY', 'http://localhost:8080/realms/urania-pa-staging'),
    oidcClientId: readEnv('VITE_OIDC_CLIENT_ID', 'spa-staging'),
    oidcRedirectUri: readEnv('VITE_OIDC_REDIRECT_URI', `${window.location.origin}/auth/callback`),
    oidcPostLogoutRedirectUri: readEnv(
      'VITE_OIDC_POST_LOGOUT_REDIRECT_URI',
      window.location.origin,
    ),
    oidcSilentRedirectUri: readEnv(
      'VITE_OIDC_SILENT_REDIRECT_URI',
      `${window.location.origin}/auth/silent-renew`,
    ),
    apiBaseUrl: readEnv('VITE_API_BASE_URL', 'http://localhost:8000'),
    auditUiEndpoint: readEnv('VITE_AUDIT_UI_ENDPOINT', ''),
  };
}
